var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-notification-media__item mc-notification-media__item--noitem"},[_c('div',{staticClass:"mc-notification-media__item--noitem-wrapper"},[_c('i',{staticClass:"mc-fa icon-outline_image-broken"}),_c('p',[_vm._v(_vm._s(_vm.$t('global.noImage')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }